export const BOAT = [
  { species: "Anglerfish",           sLbs:"30.0",  sKg:"13.608", qLbs:"15.0",  qKg:"6.804",  odLbs:"20.0",  odKg:"9.072",  mnLbs:"15.0",  mnKg:"6.804"  },
  { species: "Bass",                 sLbs:"9.8",   sKg:"4.309",  qLbs:"4.12",  qKg:"2.155",  odLbs:"6.8",   odKg:"2.948",  mnLbs:"3.0",   mnKg:"1.361"  },
  { species: "Bream (Black)",        sLbs:"3.4",   sKg:"1.474",  qLbs:"1.12",  qKg:"0.794",  odLbs:"2.10",  odKg:"1.190",  mnLbs:"1.12",  mnKg:"0.794"  },
  { species: "Bream (Couch's)",      sLbs:"4.6",   sKg:"1.985",  qLbs:"2.3",   qKg:"0.992",  odLbs:"3.8",   odKg:"1.588",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "Bream (Gilthead)",     sLbs:"5.0",   sKg:"2.268",  qLbs:"2.8",   qKg:"1.134",  odLbs:"2.10",  odKg:"1.190",  mnLbs:"2.0",   mnKg:"0.908"  },
  { species: "Bream (Pandora)",      sLbs:"3.0",   sKg:"1.361",  qLbs:"1.8",   qKg:"0.681",  odLbs:"2.8",   odKg:"1.134",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Bream (Red)",          sLbs:"3.0",   sKg:"1.361",  qLbs:"1.8",   qKg:"0.681",  odLbs:"2.0",   odKg:"0.907",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Brill",                sLbs:"4.12",  sKg:"2.155",  qLbs:"2.6",   qKg:"1.078",  odLbs:"3.4",   odKg:"1.474",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "Bull Huss",            sLbs:"14.8",  sKg:"6.577",  qLbs:"9.0",   qKg:"4.082",  odLbs:"12.8",  odKg:"5.670",  mnLbs:"9.0",   mnKg:"4.082"  },
  { species: "Coalfish",             sLbs:"7.8",   sKg:"3.420",  qLbs:"5.0",   qKg:"2.268",  odLbs:"6.8",   odKg:"2.948",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Cod",                  sLbs:"14.0",  sKg:"6.350",  qLbs:"7.0",   qKg:"3.175",  odLbs:"13.0",  odKg:"5.896",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Comber",               sLbs:"1.0",   sKg:"0.454",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.0",   odKg:"0.454",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Conger",               sLbs:"55.0",  sKg:"24.947", qLbs:"27.8",  qKg:"12.474", odLbs:"40.0",  odKg:"18.143", mnLbs:"20.0",  mnKg:"9.072"  },
  { species: "Dab",                  sLbs:"1.2",   sKg:"0.510",  qLbs:"0.9",   qKg:"0.255",  odLbs:"0.14",  odKg:"0.397",  mnLbs:"0.8",   mnKg:"0.227"  },
  { species: "Flounder",             sLbs:"3.0",   sKg:"1.361",  qLbs:"1.0",   qKg:"0.681",  odLbs:"2.0",   odKg:"0.907",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Forkbeard (Greater)",  sLbs:"4.0",   sKg:"1.814",  qLbs:"2.0",   qKg:"0.907",  odLbs:"1.10",  odKg:"0.737",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Garfish",              sLbs:"2.10",  sKg:"1.190",  qLbs:"1.5",   qKg:"0.595",  odLbs:"2.0",   odKg:"0.907",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Gurnard (Grey)",       sLbs:"1.4",   sKg:"0.567",  qLbs:"0.10",  qKg:"0.284",  odLbs:"1.0",   odKg:"0.454",  mnLbs:"0.10",  mnKg:"0.283"  },
  { species: "Gurnard (Red)",        sLbs:"2.0",   sKg:"0.907",  qLbs:"1.0",   qKg:"0.454",  odLbs:"1.8",   odKg:"0.680",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Gurnard (Tub)",        sLbs:"3.8",   sKg:"1.587",  qLbs:"1.12",  qKg:"0.794",  odLbs:"2.10",  odKg:"1.191",  mnLbs:"1.8",   mnKg:"0.680"  },
  { species: "Haddock",              sLbs:"5.0",   sKg:"2.268",  qLbs:"2.8",   qKg:"1.134",  odLbs:"4.0",   odKg:"1.814",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "Hake",                 sLbs:"8.0",   sKg:"3.628",  qLbs:"4.0",   qKg:"1.814",  odLbs:"7.0",   odKg:"3.175",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "John Dory",            sLbs:"5.12",  sKg:"2.608",  qLbs:"2.14",  qKg:"1.304",  odLbs:"4.0",   odKg:"1.814",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "L.S.D.",               sLbs:"3.0",   sKg:"1.361",  qLbs:"2.0",   qKg:"0.907",  odLbs:"2.10",  odKg:"1.191",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "Ling",                 sLbs:"26.0",  sKg:"11.793", qLbs:"14.0",  qKg:"6.350",  odLbs:"21.0",  odKg:"9.525",  mnLbs:"14.0",  mnKg:"6.350"  },
  { species: "Lumpsucker",           sLbs:"3.8",   sKg:"1.588",  qLbs:"1.12",  qKg:"0.794",  odLbs:"2.8",   odKg:"1.134",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Mackerel",             sLbs:"1.8",   sKg:"0.680",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.8",   odKg:"0.680",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Mackerel (Chub)",      sLbs:"1.4",   sKg:"0.567",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.2",   odKg:"0.397",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Megrim",               sLbs:"1.10",  sKg:"0.737",  qLbs:"0.13",  qKg:"0.369",  odLbs:"1.6",   odKg:"0.624",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Mullet (G. Grey)",     sLbs:"1.12",  sKg:"0.794",  qLbs:"0.14",  qKg:"0.397",  odLbs:"1.6",   odKg:"0.624",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Mullet (Striped Red)", sLbs:"1.8",   sKg:"0.680",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.4",   odKg:"0.567",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Mullet (Thick Lip)",   sLbs:"4.8",   sKg:"2.041",  qLbs:"2.4",   qKg:"1.021",  odLbs:"3.8",   odKg:"1.588",  mnLbs:"1.8",   mnKg:"0.680"  },
  { species: "Mullet (Thin Lip)",    sLbs:"2.2",   sKg:"0.964",  qLbs:"1.1",   qKg:"0.482",  odLbs:"1.10",  odKg:"0.737",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Plaice",               sLbs:"3.6",   sKg:"1.531",  qLbs:"1.11",  qKg:"0.766",  odLbs:"2.8",   odKg:"1.134",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Pollock",              sLbs:"12.0",  sKg:"5.442",  qLbs:"6.0",   qKg:"2.721",  odLbs:"13.0",  odKg:"5.897",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Pouting",              sLbs:"3.4",   sKg:"1.474",  qLbs:"1.10",  qKg:"0.737",  odLbs:"2.8",   odKg:"1.134",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Ray (Blonde)",         sLbs:"18.0",  sKg:"8.165",  qLbs:"9.0",   qKg:"4.083",  odLbs:"14.0",  odKg:"6.350",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Ray (Cuckoo)",         sLbs:"4.0",   sKg:"1.814",  qLbs:"3.0",   qKg:"1.361",  odLbs:"3.8",   odKg:"1.588",  mnLbs:"3.0",   mnKg:"1.361"  },
  { species: "Ray (Small Eyed)",     sLbs:"10.8",  sKg:"4.763",  qLbs:"5.4",   qKg:"2.382",  odLbs:"8.8",   odKg:"3.856",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Ray (Spotted)",        sLbs:"5.4",   sKg:"2.381",  qLbs:"3.0",   qKg:"1.361",  odLbs:"4.8",   odKg:"2.041",  mnLbs:"3.0",   mnKg:"1.361"  },
  { species: "Ray (Thornback)",      sLbs:"8.0",   sKg:"3.629",  qLbs:"5.0",   qKg:"2.268",  odLbs:"7.0",   odKg:"3.175",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Rockling (3 Beard)",   sLbs:"1.8",   sKg:"0.680",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.6",   odKg:"0.624",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Scad",                 sLbs:"1.4",   sKg:"0.567",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.2",   odKg:"0.510",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Shark (Blue)",         sLbs:"100.0", sKg:"45.360", qLbs:"50.0",  qKg:"22.680", odLbs:"90.0",  odKg:"40.823", mnLbs:"40.0",  mnKg:"18.144" },
  { species: "Shark (Porbeagle)",    sLbs:"250.0", sKg:"113.398",qLbs:"125.0", qKg:"56.699", odLbs:"200.0", odKg:"90.718", mnLbs:"40.0",  mnKg:"18.144" },
  { species: "Smooth Hound",         sLbs:"21.0",  sKg:"9.525",  qLbs:"10.8",  qKg:"4.763",  odLbs:"15.0",  odKg:"6.804",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Smooth Hound (St)",    sLbs:"21.0",  sKg:"9.525",  qLbs:"10.8",  qKg:"4.763",  odLbs:"15.0",  odKg:"6.804",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Sole (Dover)",         sLbs:"2.8",   sKg:"1.134",  qLbs:"1.4",   qKg:"0.567",  odLbs:"1.10",  odKg:"0.737",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Spurdog",              sLbs:"12.0",  sKg:"5.443",  qLbs:"6.0",   qKg:"2.722",  odLbs:"10.0",  odKg:"4.536",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Tope (C&R Only)",      sLbs:"26.0",  sKg:"11.793", qLbs:"20.0",  qKg:"9.072",  odLbs:"27.0",  odKg:"12.247", mnLbs:"20.0",  mnKg:"9.072"  },
  { species: "Triggerfish",          sLbs:"3.8",   sKg:"1.588",  qLbs:"1.12",  qKg:"0.794",  odLbs:"2.8",   odKg:"1.134",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Turbot",               sLbs:"8.0",   sKg:"3.629",  qLbs:"4.0",   qKg:"1.814",  odLbs:"7.0",   odKg:"3.175",  mnLbs:"3.0",   mnKg:"1.361"  },
  { species: "Weaver (Greater)",     sLbs:"1.10",  sKg:"0.737",  qLbs:"0.14",  qKg:"0.397",  odLbs:"1.6",   odKg:"0.624",  mnLbs:"0.14",  mnKg:"0.397"  },
  { species: "Whiting",              sLbs:"3.12",  sKg:"1.701",  qLbs:"1.14",  qKg:"0.851",  odLbs:"2.12",  odKg:"1.247",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Wrasse (Ballan)",      sLbs:"4.12",  sKg:"2.155",  qLbs:"3.0",   qKg:"1.361",  odLbs:"4.0",   odKg:"1.814",  mnLbs:"3.0",   mnKg:"1.361"  },
  { species: "Wrasse (Cuckoo)",      sLbs:"1.10",  sKg:"0.737",  qLbs:"0.13",  qKg:"0.369",  odLbs:"1.4",   odKg:"0.567",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Wreckfish",            sLbs:"7.8",   sKg:"3.402",  qLbs:"3.12",  qKg:"1.701",  odLbs:"6.8",   odKg:"2.948",  mnLbs:"1.0",   mnKg:"0.454"  },
];

export const SHORE = [
  { species: "Amberjack (Guinean)",    sLbs:"2.0",   sKg:"0.907",  qLbs:"1.0",   qKg:"0.454",  odLbs:"1.8",   odKg:"0.680",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Anglerfish",             sLbs:"30.0",  sKg:"13.608", qLbs:"15.0",  qKg:"6.804",  odLbs:"15.0",  odKg:"6.804",  mnLbs:"10.0",  mnKg:"4.536"  },
  { species: "Bass",                   sLbs:"8.0",   sKg:"3.628",  qLbs:"4.0",   qKg:"1.814",  odLbs:"5.0",   odKg:"2.267",  mnLbs:"3.0",   mnKg:"1.361"  },
  { species: "Bream (Black)",          sLbs:"2.4",   sKg:"1.021",  qLbs:"1.2",   qKg:"0.511",  odLbs:"2.0",   odKg:"0.907",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Bream (Couch's)",        sLbs:"1.8",   sKg:"0.680",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.6",   odKg:"0.624",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Bream (Gilthead)",       sLbs:"5.0",   sKg:"2.268",  qLbs:"2.8",   qKg:"1.134",  odLbs:"4.0",   odKg:"1.814",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "Bream (Pandora)",        sLbs:"1.0",   sKg:"0.454",  qLbs:"0.12",  qKg:"0.340",  odLbs:"0.14",  odKg:"0.397",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Bream (Rays)",           sLbs:"1.0",   sKg:"0.454",  qLbs:"0.12",  qKg:"0.340",  odLbs:"0.12",  odKg:"0.340",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Bream (Red)",            sLbs:"2.4",   sKg:"1.021",  qLbs:"1.2",   qKg:"0.511",  odLbs:"1.0",   odKg:"0.454",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Bream (White)",          sLbs:"1.8",   sKg:"0.680",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.0",   odKg:"0.454",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Brill",                  sLbs:"2.4",   sKg:"1.021",  qLbs:"1.2",   qKg:"0.511",  odLbs:"2.0",   odKg:"0.907",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Bull Huss",              sLbs:"13.0",  sKg:"5.897",  qLbs:"6.8",   qKg:"2.949",  odLbs:"10.0",  odKg:"4.536",  mnLbs:"8.0",   mnKg:"3.629"  },
  { species: "Coalfish",               sLbs:"1.12",  sKg:"0.794",  qLbs:"1.0",   qKg:"0.454",  odLbs:"1.10",  odKg:"0.737",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Cod",                    sLbs:"5.8",   sKg:"2.495",  qLbs:"2.12",  qKg:"1.248",  odLbs:"3.4",   odKg:"1.474",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "Conger",                 sLbs:"20.0",  sKg:"9.072",  qLbs:"10.0",  qKg:"4.536",  odLbs:"18.0",  odKg:"8.165",  mnLbs:"10.0",  mnKg:"4.536"  },
  { species: "Dab",                    sLbs:"1.2",   sKg:"0.510",  qLbs:"0.9",   qKg:"0.255",  odLbs:"0.13",  odKg:"0.369",  mnLbs:"0.8",   mnKg:"0.227"  },
  { species: "Flounder",               sLbs:"3.0",   sKg:"1.361",  qLbs:"1.8",   qKg:"0.681",  odLbs:"2.0",   odKg:"0.907",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Garfish",                sLbs:"1.12",  sKg:"0.794",  qLbs:"0.14",  qKg:"0.397",  odLbs:"1.4",   odKg:"0.567",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Gurnard (Grey)",         sLbs:"1.0",   sKg:"0.454",  qLbs:"0.8",   qKg:"0.227",  odLbs:"0.14",  odKg:"0.397",  mnLbs:"0.8",   mnKg:"0.227"  },
  { species: "Gurnard (Red)",          sLbs:"1.4",   sKg:"0.567",  qLbs:"0.10",  qKg:"0.284",  odLbs:"0.13",  odKg:"0.369",  mnLbs:"0.8",   mnKg:"0.227"  },
  { species: "Gurnard (Tub)",          sLbs:"1.8",   sKg:"0.680",  qLbs:"1.0",   qKg:"0.454",  odLbs:"1.6",   odKg:"0.623",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Haddock",                sLbs:"1.8",   sKg:"0.680",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.0",   odKg:"0.454",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Hake",                   sLbs:"2.8",   sKg:"1.134",  qLbs:"1.4",   qKg:"0.567",  odLbs:"2.0",   odKg:"0.907",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Herring",                sLbs:"0.10",  sKg:"0.283",  qLbs:"0.8",   qKg:"0.227",  odLbs:"0.10",  odKg:"0.283",  mnLbs:"0.8",   mnKg:"0.227"  },
  { species: "John Dory",              sLbs:"2.8",   sKg:"1.134",  qLbs:"1.4",   qKg:"0.567",  odLbs:"1.0",   odKg:"0.454",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Lesser Spotted Dogfish", sLbs:"3.4",   sKg:"1.474",  qLbs:"2.4",   qKg:"1.021",  odLbs:"2.10",  odKg:"1.191",  mnLbs:"2.4",   mnKg:"1.021"  },
  { species: "Ling",                   sLbs:"6.4",   sKg:"2.835",  qLbs:"3.2",   qKg:"1.418",  odLbs:"4.0",   odKg:"1.814",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "Lumpsucker",             sLbs:"5.0",   sKg:"2.268",  qLbs:"2.8",   qKg:"1.134",  odLbs:"2.0",   odKg:"0.907",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Mackerel",               sLbs:"1.12",  sKg:"0.794",  qLbs:"0.14",  qKg:"0.397",  odLbs:"1.6",   odKg:"0.624",  mnLbs:"0.10",  mnKg:"0.283"  },
  { species: "Mackerel (Spanish)",     sLbs:"1.0",   sKg:"0.454",  qLbs:"0.12",  qKg:"0.340",  odLbs:"0.14",  odKg:"0.397",  mnLbs:"0.10",  mnKg:"0.340"  },
  { species: "Megrim",                 sLbs:"1.4",   sKg:"0.567",  qLbs:"0.10",  qKg:"0.284",  odLbs:"1.0",   odKg:"0.454",  mnLbs:"0.10",  mnKg:"0.284"  },
  { species: "Monkfish",               sLbs:"20.0",  sKg:"9.072",  qLbs:"10.0",  qKg:"4.536",  odLbs:"15.0",  odKg:"6.804",  mnLbs:"10.0",  mnKg:"4.536"  },
  { species: "Mullet (G. Grey)",       sLbs:"2.6",   sKg:"1.077",  qLbs:"1.3",   qKg:"0.539",  odLbs:"1.10",  odKg:"0.737",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Mullet (Striped Red)",   sLbs:"1.4",   sKg:"0.567",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.0",   odKg:"0.454",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Mullet (Thick Lip)",     sLbs:"5.4",   sKg:"2.381",  qLbs:"2.10",  qKg:"1.191",  odLbs:"4.0",   odKg:"1.814",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "Mullet (Thin Lip)",      sLbs:"3.12",  sKg:"1.701",  qLbs:"1.14",  qKg:"0.851",  odLbs:"2.4",   odKg:"1.021",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Plaice",                 sLbs:"2.6",   sKg:"1.077",  qLbs:"1.4",   qKg:"0.567",  odLbs:"1.12",  odKg:"0.794",  mnLbs:"1.4",   mnKg:"0.567"  },
  { species: "Pollock",                sLbs:"8.0",   sKg:"3.629",  qLbs:"4.0",   qKg:"1.815",  odLbs:"5.0",   odKg:"2.268",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "Pouting",                sLbs:"1.8",   sKg:"0.680",  qLbs:"0.12",  qKg:"0.340",  odLbs:"1.0",   odKg:"0.454",  mnLbs:"0.10",  mnKg:"0.283"  },
  { species: "Ray (Blonde)",           sLbs:"12.0",  sKg:"5.443",  qLbs:"6.0",   qKg:"2.722",  odLbs:"12.0",  odKg:"5.443",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Ray (Cuckoo)",           sLbs:"4.0",   sKg:"1.814",  qLbs:"2.0",   qKg:"0.907",  odLbs:"2.4",   odKg:"1.021",  mnLbs:"2.0",   mnKg:"0.907"  },
  { species: "Ray (Electric)",         sLbs:"30.0",  sKg:"13.608", qLbs:"15.0",  qKg:"6.804",  odLbs:"20.0",  odKg:"9.072",  mnLbs:"10.0",  mnKg:"4.536"  },
  { species: "Ray (Small Eyed)",       sLbs:"10.0",  sKg:"4.536",  qLbs:"5.0",   qKg:"2.268",  odLbs:"8.8",   odKg:"3.856",  mnLbs:"6.0",   mnKg:"2.722"  },
  { species: "Ray (Spotted)",          sLbs:"5.0",   sKg:"2.268",  qLbs:"3.0",   qKg:"1.134",  odLbs:"4.0",   odKg:"1.814",  mnLbs:"3.0",   mnKg:"1.361"  },
  { species: "Ray (Sting)",            sLbs:"20.0",  sKg:"9.072",  qLbs:"10.0",  qKg:"4.536",  odLbs:"12.0",  odKg:"5.443",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Ray (Thornback)",        sLbs:"10.0",  sKg:"4.536",  qLbs:"5.0",   qKg:"2.268",  odLbs:"8.8",   odKg:"3.856",  mnLbs:"6.0",   mnKg:"2.722"  },
  { species: "Rockling (3 Beard)",     sLbs:"2.0",   sKg:"0.908",  qLbs:"1.0",   qKg:"0.454",  odLbs:"1.10",  odKg:"0.737",  mnLbs:"1.0",   mnKg:"0.454"  },
  { species: "Rockling (Shore)",       sLbs:"1.0",   sKg:"0.454",  qLbs:"0.8",   qKg:"0.227",  odLbs:"0.12",  odKg:"0.340",  mnLbs:"0.8",   mnKg:"0.227"  },
  { species: "Scad",                   sLbs:"1.0",   sKg:"0.454",  qLbs:"0.10",  qKg:"0.283",  odLbs:"0.13",  odKg:"0.369",  mnLbs:"0.10",  mnKg:"0.283"  },
  { species: "Shark (Blue)",           sLbs:"25.0",  sKg:"11.340", qLbs:"18.0",  qKg:"8.165",  odLbs:"20.0",  odKg:"9.072",  mnLbs:"18.0",  mnKg:"8.165"  },
  { species: "Smooth Hound",           sLbs:"10.0",  sKg:"4.536",  qLbs:"5.0",   qKg:"2.268",  odLbs:"7.8",   odKg:"3.402",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Smooth Hound (St)",      sLbs:"11.0",  sKg:"4.990",  qLbs:"5.8",   qKg:"2.495",  odLbs:"9.0",   odKg:"4.086",  mnLbs:"5.0",   mnKg:"2.268"  },
  { species: "Sole (Dover)",           sLbs:"1.12",  sKg:"0.794",  qLbs:"0.14",  qKg:"0.397",  odLbs:"1.4",   odKg:"0.567",  mnLbs:"0.12",  mnKg:"0.340"  },
  { species: "Spurdog",                sLbs:"10.0",  sKg:"4.536",  qLbs:"5.0",   qKg:"2.268",  odLbs:"6.8",   odKg:"2.948",  mnLbs:"3.0",   mnKg:"1.361"  },
  { species: "Tope (C&R Only)",        sLbs:"20.0",  sKg:"9.072",  qLbs:"20.0",  qKg:"9.072",  odLbs:"25.0",  odKg:"11.340", mnLbs:"20.0",  mnKg:"9.072"  },
  { species: "Triggerfish",            sLbs:"3.0",   sKg:"1.361",  qLbs:"1.8",   qKg:"0.681",  odLbs:"2.0",   odKg:"0.907",  mnLbs:"1.4",   mnKg:"0.567"  },
  { species: "Tuna (Big Eyed)",        sLbs:"60.0",  sKg:"27.216", qLbs:"30.0",  qKg:"13.608", odLbs:"40.0",  odKg:"18.144", mnLbs:"20.0",  mnKg:"9.072"  },
  { species: "Turbot",                 sLbs:"1.12",  sKg:"0.794",  qLbs:"1.2",   qKg:"0.510",  odLbs:"1.6",   odKg:"0.624",  mnLbs:"1.2",   mnKg:"0.510"  },
  { species: "Weaver (Greater)",       sLbs:"1.4",   sKg:"0.567",  qLbs:"0.10",  qKg:"0.284",  odLbs:"1.0",   odKg:"0.454",  mnLbs:"0.8",   mnKg:"0.227"  },
  { species: "Whiting",                sLbs:"2.4",   sKg:"1.020",  qLbs:"1.2",   qKg:"0.510",  odLbs:"1.8",   odKg:"0.680",  mnLbs:"0.14",  mnKg:"0.397"  },
  { species: "Wrasse (Ballan)",        sLbs:"5.8",   sKg:"2.494",  qLbs:"3.8",   qKg:"1.588",  odLbs:"4.8",   odKg:"2.041",  mnLbs:"3.8",   mnKg:"1.588"  },
  { species: "Wrasse (Cuckoo)",        sLbs:"1.2",   sKg:"0.510",  qLbs:"0.9",   qKg:"0.255",  odLbs:"0.12",  odKg:"0.340",  mnLbs:"0.8",   mnKg:"0.227"  },
];

export function parseLbsOz(str) {
  const [lbsPart, ozPart] = String(str).split(".");
  const lb = parseInt(lbsPart) || 0;
  const oz = ozPart ? parseInt(ozPart) : 0;
  return lb + oz / 16;
}

export function formatLbs(decimalLbs) {
  const totalDrms = Math.round(decimalLbs * 256);
  const lb = Math.floor(totalDrms / 256);
  const oz = Math.floor((totalDrms % 256) / 16);
  const drms = totalDrms % 16;
  if (oz === 0 && drms === 0) return `${lb} lbs`;
  if (drms === 0) return `${lb} lbs ${oz} oz`;
  return `${lb} lbs ${oz} oz ${drms} drms`;
}

// ── Champion Awards (Best total % across 5 different species) ─────────────────
export const CHAMPION_AWARDS = [
  {
    name: "Mackeson Trophy",
    description: "Club Champion – Best total CFSA Specimen percentage from 5 different species (2–3 from shore, 2–3 from boat). Senior members only.",
    type: "top5combined",
    minShore: 2,
    maxShore: 3,
    minBoat: 2,
    maxBoat: 3,
    excludesJunior: true
  },
  {
    name: "Clinton Social Club Cup",
    description: "Champion Shore Angler – Best total CFSA Specimen percentage for 5 different species (Shore).",
    type: "top5",
    location: "shore"
  },
  {
    name: "Lovett Cup",
    description: "Champion Boat Angler – Best total CFSA Specimen percentage for 5 different species (Boat).",
    type: "top5",
    location: "boat"
  }
];

// ── Species-Based Awards ──────────────────────────────────────────────────────
export const SPECIES_AWARDS = [
  {
    name: "Tom Altree Cup",
    description: "Heaviest Bass (Shore)",
    location: "shore",
    species: "Bass",
    type: "heaviest"
  },
  {
    name: "Vesta Heather Cup",
    description: "Heaviest Pollock (Shore)",
    location: "shore",
    species: "Pollock",
    type: "heaviest"
  },
  {
    name: "RSAA Heaviest Mackerel Cup",
    description: "Heaviest Mackerel (Shore)",
    location: "shore",
    species: "Mackerel",
    type: "heaviest"
  },
  {
    name: "Intrepid Cup",
    description: "Heaviest Mullet (Shore)",
    location: "shore",
    species: ["Mullet (G. Grey)", "Mullet (Striped Red)", "Mullet (Thick Lip)", "Mullet (Thin Lip)"],
    type: "heaviest"
  },
  {
    name: "Wrasse Trophy",
    description: "Heaviest Wrasse (Shore)",
    location: "shore",
    species: ["Wrasse (Ballan)", "Wrasse (Cuckoo)"],
    type: "heaviest",
    // Awarded on actual weight across both wrasse species, not CFSA specimen %.
    rankByWeight: true
  },
  {
    name: "Noel Bradbury Cup",
    description: "Heaviest Bass caught spinning with an artificial lure (Shore)",
    location: "shore",
    species: "Bass",
    type: "heaviest",
    requiresMethod: true,
    method: "artificial_lure"
  },
  {
    name: "Fred Hollis Cup",
    description: "Heaviest Bass caught from Praa Sands Beach",
    location: "shore",
    species: "Bass",
    type: "heaviest",
    requiresBeachLocation: "Praa Sands Beach"
  },
  {
    name: "Rafidae Trophy",
    description: "Heaviest Skate/Ray (Shore)",
    location: "shore",
    type: "heaviest",
    speciesPattern: /Ray|Skate/i
  },
  {
    name: "K Mundy Memorial Trophy",
    description: "Best Specimen Flatfish (Shore)",
    location: "shore",
    type: "heaviest",
    species: ["Plaice", "Dab", "Flounder", "Brill", "Sole (Dover)", "Turbot", "Megrim"]
  },
  {
    name: "ABU Cup",
    description: "Best specimen caught surf fishing from a North Coast Beach",
    location: "shore",
    type: "heaviest",
    requiresBeachLocation: "North Coast Beach"
  },
  // ── Boat Awards ──────────────────────────────────────────────────────────────
  {
    name: "Opie and Wakeling Cup",
    description: "Heaviest Pollock (Boat)",
    location: "boat",
    species: "Pollock",
    type: "heaviest"
  },
  {
    name: "Stephens and Viant Cup",
    description: "Heaviest Bream (Boat)",
    location: "boat",
    species: ["Bream (Black)", "Bream (Couch's)", "Bream (Gilthead)", "Bream (Pandora)", "Bream (Red)"],
    type: "heaviest",
    // Awarded on actual weight across all bream species, not CFSA specimen %.
    rankByWeight: true
  },
  {
    name: "Thomas William Cup",
    description: "Best Specimen caught on a club boat trip",
    location: "boat",
    type: "heaviest",
    requiresClubBoatTrip: true
  },
  {
    name: "R.S.A.A Cup",
    description: "Best Other Specimen (Boat) – excludes fish eligible for any other senior Boat or Boat & Shore trophy",
    location: "boat",
    type: "heaviest",
    // Species covered by other senior trophies: Opie and Wakeling (Pollock), Stephens and Viant (Bream),
    // Conger Cup, Phil Kevern Cup (Greater Spotted Dogfish / Bull Huss) and Tope Trophy.
    excludeSpecies: ["Pollock", "Bream (Black)", "Bream (Couch's)", "Bream (Gilthead)", "Bream (Pandora)", "Bream (Red)", "Conger", "Bull Huss", "Tope (C&R Only)"],
    // Thomas William Cup isn't species-based, so exclude the catch that wins it instead.
    excludeWinnersOf: ["Thomas William Cup"]
  },
  {
    name: "Ron Stevens Cup",
    description: "Best Specimen by a Junior (Boat) – junior whose best specimen does not win a senior boat trophy",
    location: "boat",
    type: "heaviest",
    requiresJunior: true
  },
  // ── Ladies Shore Awards ──────────────────────────────────────────────────────
  {
    name: "Arthur Paul Cup",
    description: "Heaviest Bass (Ladies Shore)",
    location: "shore",
    species: "Bass",
    type: "heaviest",
    requiresLadies: true
  },
  {
    name: "Andrew Cup",
    description: "Heaviest Mackerel (Ladies Shore)",
    location: "shore",
    species: "Mackerel",
    type: "heaviest",
    requiresLadies: true
  },
  {
    name: "Norman Tucker Cup",
    description: "Best Specimen Flatfish (Ladies Shore)",
    location: "shore",
    species: ["Plaice", "Dab", "Flounder", "Brill", "Sole (Dover)", "Turbot", "Megrim"],
    type: "heaviest",
    requiresLadies: true
  },
  {
    name: "Altree and Channon Cup",
    description: "Best Other Specimen (Ladies Shore) – excludes species covered by the other Ladies Shore trophies",
    location: "shore",
    type: "heaviest",
    requiresLadies: true,
    excludeSpecies: ["Bass", "Mackerel", "Mackerel (Spanish)", "Plaice", "Dab", "Flounder", "Brill", "Sole (Dover)", "Turbot", "Megrim"]
  },
  // ── Junior Shore Awards ──────────────────────────────────────────────────────
  {
    name: "Browne Cup",
    description: "Heaviest Bass (Junior Shore)",
    location: "shore",
    species: "Bass",
    type: "heaviest",
    requiresJunior: true
  },
  {
    name: "Francis Johns Cup",
    description: "Heaviest Pollock (Junior Shore)",
    location: "shore",
    species: "Pollock",
    type: "heaviest",
    requiresJunior: true
  },
  {
    name: "Hugh Pengelly Cup",
    description: "Heaviest Mackerel (Junior Shore)",
    location: "shore",
    species: "Mackerel",
    type: "heaviest",
    requiresJunior: true
  },
  {
    name: "Tredinnick Cup",
    description: "Best Specimen Flatfish (Junior Shore)",
    location: "shore",
    species: ["Plaice", "Dab", "Flounder", "Brill", "Sole (Dover)", "Turbot", "Megrim"],
    type: "heaviest",
    requiresJunior: true
  },
  {
    name: "One and All Sports Trophy",
    description: "Heaviest Wrasse (Junior Shore)",
    location: "shore",
    species: ["Wrasse (Ballan)", "Wrasse (Cuckoo)"],
    type: "heaviest",
    requiresJunior: true
  },
  {
    name: "Knuckey Cup",
    description: "Best Specimen Mullet (Junior Shore)",
    location: "shore",
    species: ["Mullet (G. Grey)", "Mullet (Striped Red)", "Mullet (Thick Lip)", "Mullet (Thin Lip)"],
    type: "heaviest",
    requiresJunior: true
  },
  {
    name: "Holiday Boat Centre Cup",
    description: "Best Other Specimen (Junior Shore) – excludes species covered by the other Junior Shore trophies",
    location: "shore",
    type: "heaviest",
    requiresJunior: true,
    excludeSpecies: ["Bass", "Pollock", "Mackerel", "Plaice", "Dab", "Flounder", "Brill", "Sole (Dover)", "Turbot", "Megrim", "Wrasse (Ballan)", "Wrasse (Cuckoo)", "Mullet (G. Grey)", "Mullet (Striped Red)", "Mullet (Thick Lip)", "Mullet (Thin Lip)"]
  }
];
